import {

    FormControl,
    InputLabel,
    Select,
    FormHelperText
} from "@mui/material";


export default function SelectField(props) {

    const {
        label,
        value,
        onChange,
        error,
        helperText,
        fullWidth,
        children,
        required,
        selectProps,
        ...other

    } = props;

    return (<FormControl
        fullWidth={fullWidth}
        error={error}
        {...other}
    >
        <InputLabel>{label}</InputLabel>
        <Select
            required={required}
            label={label}
            value={value}
            onChange={onChange}
            {...selectProps}
        >
            {children}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>);
}